export const TablePaginationTypes: number[] = [10, 20, 40];

export enum TableTypes {
  boolean = 'boolean',
  actions = 'actions',
  bulk = 'bulk',
  date = 'date',
  custom = 'custom',
}
